// extracted by mini-css-extract-plugin
export default {"cls1":"GrG9HqNRZNbgnKRUKbHA","cls2":"D75AoQgmojzmmS7TsMCi GrG9HqNRZNbgnKRUKbHA"};